import * as actionTypes from "../actionTypes";

export const uploadLabelsList = (data) => {
  return {
    type: actionTypes.UPLOAD_LABELS_LIST_START,
    payload: data,
  };
};

export const getLabelsList = (data) => {
  return {
    type: actionTypes.GET_LABELS_LIST_START,
    payload: data,
  };
};
export const getLabelsListSuccess = (data) => {
  return {
    type: actionTypes.GET_LABELS_LIST_SUCCESS,
    payload: data,
  };
};
export const getLabelsListFailure = (error) => {
  return {
    type: actionTypes.GET_LABELS_LIST_FAILURE,
    payload: error,
  };
};

export const getLabelServiceList = (data) => {
  return {
    type: actionTypes.GET_LABELS_SERVICE_LIST_START,
    payload: data,
  };
};
export const getLabelServiceListSuccess = (data) => {
  return {
    type: actionTypes.GET_LABELS_SERVICE_LIST_SUCCESS,
    payload: data,
  };
};
export const getLabelServiceListFailure = (error) => {
  return {
    type: actionTypes.GET_LABELS_SERVICE_LIST_FAILURE,
    payload: error,
  };
};

export const getParentLabelList = (data) => {
  return {
    type: actionTypes.GET_PARENT_LABELS_LIST_START,
    payload: data,
  };
};
export const getParentLabelListSuccess = (data) => {
  return {
    type: actionTypes.GET_PARENT_LABELS_SUCCESS,
    payload: data,
  };
};
export const getParentLabelListFailure = (error) => {
  return {
    type: actionTypes.GET_PARENT_LABELS_FAILURE,
    payload: error,
  };
};

export const addNewParentLabel = (data) => {
  return {
    type: actionTypes.ADD_NEW_PARENT_LABEL_START,
    payload: data,
  };
};

export const addNewLabelService = (data) => {
  return {
    type: actionTypes.ADD_NEW_LABEL_SERVICE_START,
    payload: data,
  };
};
export const editLabelService = (data) => {
  return {
    type: actionTypes.EDIT_LABEL_SERVICE_START,
    payload: data,
  };
};
export const licenseLabelStart = (data) => {
  return {
    type: actionTypes.LICENSE_LABEL_START,
    payload: data,
  };
};
export const addNewLabel = (data) => {
  return {
    type: actionTypes.ADD_NEW_LABEL_START,
    payload: data,
  };
};
export const addNewLabelSuccess = (data) => {
  // console.log({data})
  let message = data?.message || ' success'
  return {
    type: actionTypes.ADD_NEW_LABEL_SUCCESS,
    payload: {message},
  };
};
export const addNewLabelFailure = (error) => {
  return {
    type: actionTypes.ADD_NEW_LABEL_FAILURE,
    payload: error,
  };
};

export const getParentLabelData = (data) => {
  return {
    type: actionTypes.GET_PARENT_LABEL_DATA_START,
    payload: data,
  };
};
export const getParentLabelDataSuccess = (data) => {
  return {
    type: actionTypes.GET_PARENT_LABEL_DATA_SUCCESS,
    payload: data,
  };
};
export const getParentLabelDataFailure = (error) => {
  return {
    type: actionTypes.GET_PARENT_LABEL_DATA_FAILURE,
    payload: error,
  };
};

// set active label service id to fetch licensed territories
export const activeLabelService = (data) => {
  return {
    type: actionTypes.ACTIVE_lABEL_SERVICE,
    payload: data,
  };
};

export const labelsMessageHandler = () => {
  return {
    type: actionTypes.LABELS_MESSAGE_HANDLER,
    payload: null,
  };
};
